import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';

const root = (state: ReduxStore) => state.kvdHelper;

export const showDato = createSelector(root, kvdHelper => kvdHelper.showDato);
